import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import ProductDimension from "./ProductDimension";
import { useSelector } from "react-redux";

const ProductImage = ({
  files,
  filesDescs,
  register,
  errors,
  wrapStyle,
  onRemoveFile,
  onFileChange,
  onAddFileDesc,
  approval_status,
  next_step_nik_detail,
}) => {
  console.log(filesDescs);
  let { userInfo } = useSelector((state) => state.auth);
  const genFileIndex = (file) => {
    const name = file.fileName || file.name || file.file_name;
    return name.split(" ").join("");
  };

  const [fileUrls, setFileUrls] = useState([]);

  /*useEffect(() => {
    console.log(files);
    console.log(fileUrls);
  }, [fileUrls]);*/

  useEffect(() => {
    if (files && files?.length > 0) {
      // Create object URLs for the files
      const newFileUrls = files.map((file) => {
        if (!file.url) {
          return URL.createObjectURL(file);
        } else return file.url;
      });

      // Update state with the new file URLs
      setFileUrls(newFileUrls);

      // Clean up the URL objects when the component unmounts or files change
      return () => {
        newFileUrls.forEach((url) => {
          if (!files.find((file) => file.url === url)) {
            URL.revokeObjectURL(url);
          }
        });
      };
    }
  }, [files]);

  return (
    <div>
      {/*<ProductDimension register={register} errors={errors} countDimension={countDimension} />*/}
      <div className="card mt-3">
        <div className="card-header">
          <div className="card-title" style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div>
                <i className="fa fa-camera" /> Product Image
              </div>
              <div>
                <input
                  id="file-image"
                  className="d-none"
                  type="file"
                  accept="image/png, image/jpg, image/jpeg"
                  onChange={onFileChange}
                  name={"product-image"}
                  multiple={true}
                />
                {approval_status != "ONPROGRESS" &&
                  (approval_status != "ONREVISED" ||
                    next_step_nik_detail == userInfo.nik) && (
                    <a
                      type="button"
                      className="btn btn-outline-warning btn-pmc"
                      style={{ width: 120 }}
                      onClick={() => {
                        window.$("#file-image").click();
                      }}
                    >
                      <i className="fa fa-image" /> Choose{" "}
                    </a>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="form-group">
            <div
              className="d-flex"
              style={{ margin: "16px 0", flexFlow: "wrap", padding: 10 }}
            >
              {files &&
                files.length > 0 &&
                files.map((file, i) => {
                  console.log(files);
                  let fileIndex = genFileIndex(file);
                  //console.log(fileIndex);
                  if (!files[fileIndex] && file.fileIndex)
                    fileIndex = file.fileIndex;
                  //console.log(fileIndex);

                  return (
                    <div key={"key_file_" + i} style={{ display: "flex" }}>
                      <div style={wrapStyle}>
                        <div
                          style={{ position: "absolute", right: -10, top: -10 }}
                        >
                          <Button
                            type="button"
                            className="p-button-rounded p-button-danger"
                            icon="pi pi-times"
                            visible={
                              approval_status !== "ONPROGRESS" &&
                              (approval_status !== "ONREVISED" ||
                                next_step_nik_detail == userInfo.nik)
                            }
                            style={{ width: 30, height: 30 }}
                            onClick={(e) => {
                              fileUrls.splice(i, 1);
                              setFileUrls(fileUrls);
                              onRemoveFile(file, i);
                            }}
                          />
                        </div>
                        {/*<img src={URL.createObjectURL(file)} style={{ objectFit: 'contain', width: '100%', height: '100%', borderRadius: 4, marginBottom: 20, cursor: 'pointer' }} onClick={() => onAddFileDesc(file)} />*/}
                        <img
                          src={file.url || fileUrls[i]}
                          style={{
                            objectFit: "contain",
                            width: "100%",
                            height: "100%",
                            borderRadius: 4,
                            marginBottom: 20,
                            cursor: "pointer",
                          }}
                          onClick={() => onAddFileDesc(file)}
                        />
                      </div>

                      {filesDescs[fileIndex] &&
                        (filesDescs[fileIndex].media_types.length > 0 ||
                          filesDescs[fileIndex].content_types.length > 0) && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              marginRight: 10,
                            }}
                          >
                            <div style={{ width: 85, marginTop: 15 }}>
                              {filesDescs[fileIndex].media_types.map(
                                (item, i) => {
                                  if (i < 2) {
                                    return (
                                      <p
                                        key={"media_" + item}
                                        style={{
                                          fontSize: 12,
                                          marginTop: -15,
                                          backgroundColor: "#ffe99b",
                                          paddingLeft: 2,
                                          borderRadius: 5,
                                          color: "#000",
                                        }}
                                      >
                                        {item}
                                      </p>
                                    );
                                  }
                                }
                              )}
                              {filesDescs[fileIndex].media_types.length - 2 >
                                0 && (
                                  <p
                                    key={"media_key"}
                                    style={{
                                      fontSize: 12,
                                      marginTop: -15,
                                      backgroundColor: "#ffe99b",
                                      paddingLeft: 2,
                                      borderRadius: 5,
                                      width: 35,
                                      color: "#000",
                                    }}
                                  >
                                    {filesDescs[fileIndex].media_types.length - 2}
                                    +
                                  </p>
                                )}
                            </div>

                            <div style={{ width: 85, marginTop: 5 }}>
                              {filesDescs[fileIndex].content_types.map(
                                (item, i) => {
                                  if (i < 2) {
                                    return (
                                      <p
                                        key={"content_" + item}
                                        style={{
                                          fontSize: 12,
                                          marginTop: -15,
                                          backgroundColor: "#ffe99b",
                                          paddingLeft: 2,
                                          borderRadius: 5,
                                          color: "#000",
                                        }}
                                      >
                                        {item}
                                      </p>
                                    );
                                  }
                                }
                              )}
                              {filesDescs[fileIndex].content_types.length - 2 >
                                0 && (
                                  <p
                                    key={"content_key"}
                                    style={{
                                      fontSize: 12,
                                      marginTop: -15,
                                      backgroundColor: "#ffe99b",
                                      paddingLeft: 2,
                                      borderRadius: 5,
                                      width: 35,
                                      color: "#000",
                                    }}
                                  >
                                    {filesDescs[fileIndex].content_types.length -
                                      2}
                                    +
                                  </p>
                                )}
                            </div>
                          </div>
                        )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductImage;
